<!-- eslint-disable vue-i18n/no-missing-keys -->
<template>
<v-layout >
  <v-layout column>
    <v-flex xs12>
      <v-data-table
        :headers="headers"
        :items="items"
        :pagination.sync="pagination"
        :total-items="totalItems"
        :rows-per-page-items="[5,10,25]"
        :loading="loading || inLoading"
        :expand="$vuetify.breakpoint.mdAndDown"
      >
        <template slot="items" slot-scope="props">
          <tr 
            :class="{ 
              pointer: $vuetify.breakpoint.mdAndDown, 
              'error--text':(estaCaducada(props.item) && !terminada(props.item))
            }" 
            @click="props.expanded = !props.expanded"
          >
            <td class="text-xs-left hidden-md-and-down tableSmallPadding">
              <v-layout row>
                {{props.item.nombre_cliente ? props.item.nombre_cliente: props.item.nombreComprador}}
                <v-spacer
                  v-if="$vuetify.breakpoint.lgOnly" 
                />
                <v-icon 
                  v-if="$vuetify.breakpoint.lgOnly" 
                  :style="props.expanded ? 'transform: rotate(-180deg)' : ''"
                > 
                  keyboard_arrow_down 
                </v-icon>
              </v-layout>
            </td>
            <td class="text-xs-center tableSmallPadding" >{{ props.item.tipoReserva }}</td>
            <td class="text-xs-center hidden-lg-and-down tableSmallPadding" >{{ props.item.promocion_descripcion }}</td>
            <td class="tableSmallPadding">
              <v-layout row justify-center :class="$vuetify.breakpoint.mdAndDown ? 'text-xs-left' : 'text-xs-center'">
                {{props.item.inmueble_descripcionLarga}}
                <v-spacer
                  v-if="$vuetify.breakpoint.mdAndDown" 
                />
                <v-icon 
                  v-if="$vuetify.breakpoint.mdAndDown" 
                  :style="props.expanded ? 'transform: rotate(-180deg)' : ''"
                > 
                  keyboard_arrow_down 
                </v-icon>
              </v-layout>
            </td>
            <td class="text-xs-right hidden-sm-and-down tableSmallPadding">{{ props.item.tarifa_importeTotal | currency}}</td>
            <td class="text-xs-center tableSmallPadding">{{ props.item.fechaAlta | formatDateTime }}</td>
            <td v-if="esAdministrador || esCliente || esComercial" class="text-xs-center hidden-sm-and-down tableSmallPadding">
              <v-layout align-center justify-center>
                <div v-for="modulo in props.item.modulosOrden.modulos" :key="modulo.id" class="modulosStyle" :class="getModuloEstado(modulo.tipo, props.item) ">
                  <v-tooltip bottom>
                    <div style="width: 100%; height: 100%" slot="activator"></div>
                    <span>{{modulo.tipo == 'firmakyc' ? modulo.nombre : getTexto('modulos.' + modulo.tipo + (props.item.cod_tipo_operacion === 'ALQ' ? 'Alquiler' : ''))}}</span>
                  </v-tooltip>
                </div>
              </v-layout>
            </td>
            <td class="text-xs-center hidden-sm-and-down tableSmallPadding">{{ situacionReserva(props.item) }}</td>
            <td class="text-xs-right hidden-sm-and-down tableSmallPadding" style="min-width: 134px">
              <v-btn 
                v-if="(esPbc || esCliente) && !esAdministrador && !esComercial"
                color="primary" 
                @click.stop="mostrarVistaPrevia(props.item)"
              >
                {{$t('reservas.listas.gestionar')}}
              </v-btn>
              <v-tooltip bottom v-if="(esAdministrador || esComercial)">
                <v-btn
                  flat icon slot="activator" 
                  class="smallTableButton" 
                  @click.stop="mostrarVistaPrevia(props.item)"
                >
                  <v-icon color="primary" class="custom-icon">
                    icon-action_preview
                  </v-icon>
                </v-btn>
                <span>{{$t('reservas.listas.gestionar')}}</span>
              </v-tooltip>
              <v-tooltip bottom v-if="!eliminadaOAnulada(props.item) && estaCaducada(props.item) && !terminada(props.item) && (esAdministrador || esComercial)">
                <v-btn flat icon slot="activator" class="smallTableButton" @click.stop="mostrarCambiarEstado(props.item)">
                  <v-icon color="primary">
                    date_range
                  </v-icon>
                </v-btn>
                <span>{{$t('reservas.listas.cambiarEstado')}}</span>
              </v-tooltip>
              <v-tooltip bottom v-if="props.item.nombre_cliente && props.item.sincronizada && !terminada(props.item) && !eliminadaOAnulada(props.item) && !estaCaducada(props.item) && (esAdministrador || esComercial)">
                <v-btn 
                  flat icon
                  slot="activator"
                  :disabled="reservaEnRevision(props.item)"
                  class="smallTableButton" 
                  @click.stop="mostrarEnviarRecordatorio(props.item)"
                >
                  <v-icon color="primary" class="custom-icon">
                    icon-action_change_state
                  </v-icon>
                </v-btn>
                <span>{{$t('reservas.listas.enviarRecordatorioMinusculas')}}</span>
              </v-tooltip>
              <v-tooltip bottom v-if="!props.item.sincronizada && !eliminadaOAnulada(props.item) && !estaCaducada(props.item) && (esAdministrador || esComercial)">
                <v-btn 
                  flat icon 
                  slot="activator" 
                  class="smallTableButton" 
                  @click.stop="mostrarSincronizar(props.item)"
                >
                  <v-icon color="primary">
                    autorenew
                  </v-icon>
                </v-btn>
                <span>{{$t('reservas.listas.sincronizar')}}</span>
              </v-tooltip>
              <v-tooltip bottom v-if="!eliminadaOAnulada(props.item) && (esAdministrador || esComercial)">
                <v-btn flat icon slot="activator" class="smallTableButton" @click.stop="mostrarEliminar(props.item)">
                  <v-icon color="primary" class="custom-icon">
                    icon-action_erase
                  </v-icon>
                </v-btn>
                <span>{{$t('reservas.listas.eliminarMinusculas')}}</span>
              </v-tooltip>
            </td>
            <td class="text-xs-right hidden-md-and-up tableSmallPadding">
              <v-btn 
                v-if="(esPbc || esCliente) && !esAdministrador && !esComercial"
                flat icon slot="activator" class="smallTableButton" 
                @click.stop="mostrarVistaPrevia(props.item)"
              >
                <v-icon color="primary">
                  arrow_forward
                </v-icon>
              </v-btn>
              <v-menu transition="scale-transition"
              origin="top right" v-else-if="(esAdministrador || esComercial)" offset-y left @click.native.stop>
                <v-btn
                  flat icon title="Gestionar" 
                  slot="activator" 
                  class="smallTableButton"
                >
                  <v-icon color="primary">
                    more_vert
                  </v-icon>
                </v-btn>
                <v-list dense>
                  <v-list-tile 
                    @click.stop="mostrarVistaPrevia(props.item)"
                  >
                    <v-list-tile-action>
                      <v-icon color="primary" class="custom-icon"> icon-action_preview </v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <v-list-tile-title>
                        {{$t('reservas.listas.gestionar')}}
                      </v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile 
                    v-if="!eliminadaOAnulada(props.item) && estaCaducada(props.item) && !terminada(props.item) && (esAdministrador || esComercial)" 
                    @click.stop="mostrarCambiarEstado(props.item)"
                  >
                    <v-list-tile-action>
                      <v-icon color="primary"> date_range </v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <v-list-tile-title>
                        {{$t('reservas.listas.cambiarEstado')}}
                      </v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile 
                    v-if="props.item.sincronizada && !eliminadaOAnulada(props.item) && !estaCaducada(props.item) && !terminada(props.item)" 
                    @click.stop="mostrarEnviarRecordatorio(props.item)"
                    :disabled="reservaEnRevision(props.item)"
                  >
                    <v-list-tile-action>
                      <v-icon :disabled="reservaEnRevision(props.item)" color="primary" class="custom-icon"> icon-action_change_state </v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <v-list-tile-title>
                        {{$t('reservas.listas.enviarRecordatorioMinusculas')}}
                      </v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile 
                    v-if="!props.item.sincronizada && !estaCaducada(props.item) && !eliminadaOAnulada(props.item)"
                    @click.stop="mostrarSincronizar(props.item)"
                  >
                    <v-list-tile-action>
                      <v-icon color="primary"> autorenew </v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <v-list-tile-title>
                        {{$t('reservas.listas.sincronizar')}}
                      </v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile
                    @click.stop="mostrarEliminar(props.item)"
                  >
                    <v-list-tile-action>
                      <v-icon color="primary" class="custom-icon"> icon-action_erase </v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <v-list-tile-title>
                        {{$t('reservas.listas.eliminarMinusculas')}}
                      </v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-menu>
            </td>
          </tr>
        </template>
        <template v-if="$vuetify.breakpoint.lgAndDown" slot="expand" slot-scope="props">
          <v-list dense>
            <v-list-tile>
              <v-list-tile-action>
                <v-tooltip bottom>
                  <v-icon color="primary" slot="activator"> person </v-icon>
                  <span>{{$t('reservas.listas.cliente')}}</span>
                </v-tooltip>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-layout row align-center>
                  <v-flex>
                    {{props.item.nombre_cliente ? props.item.nombre_cliente: props.item.nombreComprador}}
                  </v-flex>
                </v-layout>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile>
              <v-list-tile-action>
                <v-tooltip bottom>
                  <span>{{$t('reservaSimplificada.filtroReservas')}}</span>
                </v-tooltip>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-layout row align-center>
                  <v-flex>
                    {{props.item.tipoReserva}}
                  </v-flex>
                </v-layout>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile>
              <v-list-tile-action>
                <v-tooltip bottom>
                  <v-icon color="primary" class="custom-icon icon-promociones" slot="activator"/>
                  <span>{{$t('reservas.listas.promocion')}}</span>
                </v-tooltip>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-layout row align-center>
                  <v-flex>
                    {{props.item.promocion_descripcion}}
                  </v-flex>
                </v-layout>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile>
              <v-list-tile-action>
                <v-tooltip bottom>
                  <v-icon color="primary" class="custom-icon icon-inmueble" slot="activator"/>
                  <span>{{$t('reservas.listas.inmueble')}}</span>
                </v-tooltip>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-layout row align-center>
                  <v-flex class="list-text-overflow">
                  {{props.item.inmueble_descripcionLarga}}
                  </v-flex>
                </v-layout>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile>
              <v-list-tile-action>
                <v-tooltip bottom>
                  <v-icon color="primary" class="custom-icon icon-importe" slot="activator"/>
                  <span>{{$t('reservas.listas.importeTotal')}}</span>
                </v-tooltip>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-layout row justify-center align-center>
                  <v-flex class="list-text-overflow">
                    {{props.item.tarifa_importeTotal | currency}}
                  </v-flex>
                </v-layout>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile>
              <v-list-tile-action>
                <v-tooltip bottom>
                  <v-icon color="primary" slot="activator">date_range</v-icon>
                  <span>{{$t('reservas.listas.fechaAlta')}}</span>
                </v-tooltip>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-layout row align-center>
                  <v-flex class="list-text-overflow">
                    {{props.item.fechaAlta | formatDateTime}}
                  </v-flex>
                </v-layout>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile v-if="esAdministrador || esCliente || esComercial">
              <v-list-tile-action>
                <v-tooltip bottom>
                  <v-icon color="primary" class="custom-icon icon-estado" slot="activator"/>
                  <span>{{$t('reservas.listas.estado')}}</span>
                </v-tooltip>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-layout style="margin: 0px" row align-center>
                  <div v-for="modulo in props.item.modulosOrden.modulos" :key="modulo.id" class="modulosStyle" :class="getModuloEstado(modulo.tipo, props.item) ">
                    <v-tooltip bottom>
                      <div style="width: 100%; height: 100%" slot="activator"></div>
                      <span>{{modulo.tipo == 'firmakyc' ? $t('configuracion.kyc') : getTexto('modulos.' + modulo.tipo + (props.item.cod_tipo_operacion === 'ALQ' ? 'Alquiler' : ''))}}</span>
                    </v-tooltip>
                  </div>
                </v-layout>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile>
              <v-list-tile-action>
                <v-tooltip bottom>
                  <v-icon color="primary" slot="activator">mdi-information</v-icon>
                  <span>{{$t('reservas.listas.situacionReserva')}}</span>
                </v-tooltip>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-layout row align-center>
                  <v-flex class="list-text-overflow">
                    {{ situacionReserva(props.item) }}
                  </v-flex>
                </v-layout>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </template>
      </v-data-table>
    </v-flex>
  </v-layout>
  <v-fade-transition>
    <custom-dialog 
      v-if="mostrarPopUpCambiarEstado"
      v-model="mostrarPopUpCambiarEstado"
      :cambiado="cambiado"
      @aceptar="mostrarPopUpCambiarEstado = $event"
    >
      <PopUpCambiarEstado 
        :reserva="reservaSeleccionada" 
        @recargar="loadItems"
        @cambiado="cambiado = $event"
      />
    </custom-dialog>
  </v-fade-transition>
  <v-fade-transition>
    <custom-dialog v-if="mostrarPopUpEnviarRecordatorio" v-model="mostrarPopUpEnviarRecordatorio">
      <PopUpEnviarRecordatorio :reservaSeleccionada="reservaSeleccionada"/>
    </custom-dialog>
  </v-fade-transition>
  <v-fade-transition>
    <custom-dialog v-if="mostrarPopUpSincronizar" v-model="mostrarPopUpSincronizar">
      <PopUpSincronizar :reservaSeleccionada="reservaSeleccionada" @recargar="initialize"/>
    </custom-dialog>
  </v-fade-transition>
  <v-fade-transition>
    <custom-dialog v-if="mostrarPopUpEliminar" v-model="mostrarPopUpEliminar">
      <PopUpEliminarReserva
        @aceptar="eliminarReserva"
        @eliminadaBO="eliminadaBO" 
        :reservaId="reservaSeleccionada.id"
        :saving="eliminandoReserva"
        :pregunta="$t('reservas.listas.preguntaEliminarReserva', {inmueble: reservaSeleccionada.inmueble_descripcionLarga, nombre: nombreActor(), date: $options.filters['formatDateTime'](reservaSeleccionada.fechaAlta)})"
        :descartar="$t('general.misc.eliminar')"
        :cancelar="$t('general.popUpSeguro.cancelar')"
      />
    </custom-dialog>
  </v-fade-transition>
</v-layout>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import PopUpCambiarEstado from './PopUpCambiarEstado'
import PopUpEnviarRecordatorio from './PopUpEnviarRecordatorio'
import PopUpSincronizar from './PopUpSincronizar'
import PopUpEliminarReserva from './PopUpEliminarReserva'
import modulos from '@/mixins/modulos'
import moment from 'moment'
import rulesMixin from '@/mixins/rules.js'
import _ from 'lodash'

export default {
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    promocionesSelect: {
      type: Array,
      required: true
    },
    tipoReserva: {
      type: String
    },
    checkSelect: {
      type: Array,
      required: true
    },
    search: {
      type: String,
      default: null
    },
    searchFields: {
      type: Array,
      required: true
    },
    tipo: {
      type: String,
      default: null
    }
  },
  mixins: [
    modulos,
    rulesMixin
  ],
  components: {
    PopUpCambiarEstado,
    PopUpEnviarRecordatorio,
    PopUpSincronizar,
    PopUpEliminarReserva
  },
  data () {
    return {
      pagination: {
        descending: true,
        rowsPerPage: 5,
        sortBy: 'fechaAlta',
        page: 1,
        totalItems: 0
      },
      items: [],
      totalItems: 0,
      mostrarPopUpCambiarEstado: false,
      mostrarPopUpEnviarRecordatorio: false,
      mostrarPopUpEliminar: false,
      mostrarPopUpSincronizar: false,
      expandirAcciones: false,
      cambiado: false,
      reservaSeleccionada: null,
      eliminandoReserva: false,
      inLoading: false
    }
  },
  created () {
    /* Debounce hace que la funcion se llame pasados X milisegundos,
      si se llama muchas veces solo se ejecuta la última */
    this.loadItems = _.debounce(this.loadItems, 300)
    this.initialize()
  },
  computed: {
    ...mapGetters({
    }),
    headers () {
      let totalHeaders = []
      totalHeaders = [
        {
          text: this.$t('reservas.listas.cliente'),
          value: 'nombre_cliente',
          align: 'left',
          class: 'hidden-md-and-down',
          sortable: true
        },
        {
          text: this.$t('reservaSimplificada.filtroReservas'),
          value: 'tipo_reserva',
          align: 'left',
          class: 'hidden-sm-and-down',
          sortable: true
        },
        {
          text: this.$t('reservas.listas.promocion'),
          value: 'promocion_descripcion',
          align: 'center',
          class: 'hidden-lg-and-down',
          sortable: true
        },
        {
          text: this.$t('reservas.listas.inmueble'),
          value: 'inmueble_descripcionLarga',
          align: this.$vuetify.breakpoint.mdAndDown ? 'left' : 'center',
          sortable: true
        },
        {
          text: this.$t('reservas.listas.importe'),
          value: 'tarifa_importeTotal',
          align: 'right',
          class: 'hidden-sm-and-down pr-2',
          sortable: true
        },
        {
          text: this.$t('reservas.listas.fechaAlta'),
          value: 'fechaAlta',
          align: 'center',
          sortable: true,
          class: this.$vuetify.breakpoint.xsOnly ? 'px-0' : '',
          searchValue: 'fechaAltaFormatted'
        },
        {
          text: this.$t('reservas.listas.estado'),
          value: 'codigoEstadoReserva',
          align: 'center',
          class: 'hidden-sm-and-down',
          sortable: true
        },
        {
          text: this.$t('reservas.listas.situacion'),
          value: 'situacion',
          align: 'center',
          class: 'hidden-sm-and-down',
          sortable: true
        },
        {
          text: this.$vuetify.breakpoint.smAndDown ? '' : this.$t('reservas.listas.acciones'),
          align: 'right',
          sortable: false
        }
      ]
      return this.esAdministrador || this.esCliente || this.esComercial ? totalHeaders : totalHeaders.filter(x => x.value !== 'estado')
    }
  },
  methods: {
    ...mapActions({
      loadAllReservas: 'reservas/loadAll',
      eliminar: 'reservas/eliminar',
      addAlert: 'alerts/add'
    }),
    async initialize () {
      try {
        await Promise.all([
          this.loadItems()
        ])
        if (this.totalItems === 1) {
          this.$router.push({
            name: 'reservas.id',
            params: {
              id: this.items[0].id,
              skip: true
            }
          })
        }
      } catch (error) {
        if (!error.code || error.code !== 1) {
          this.addAlert({texto: error.message, color: 'error'})
        }
      }
    },
    async loadItems () {
      this.inLoading = true
      try {
        const apiResponse = await this.loadAllReservas({
          filtros: {
            ...this.pagination,
            search: this.search !== null && this.search.length >= 3 ? this.search : null,
            searchFields: this.searchFields
          },
          tipoReserva: this.tipoReserva,
          promociones: this.promocionesSelect,
          checks: this.checkSelect,
          tipo: this.tipo ? (this.tipo === 'VENTA' ? 'VTA' : 'ALQ') : null
        })
        this.items = apiResponse.items
        this.items.forEach(reserva => {
          if (reserva.modulosOrden.simplificada == 1 && reserva.modulosOrden.generarContratoKyc) {

            reserva.modulosOrden.modulos.splice(2, 0, {
              crearReserva: false,
              id: null,
              modulosOrdenId: null,
              nombre: this.$t('configuracion.kyc'),
              tipo: 'firmakyc'
            });
          }
         
        })
        this.totalItems = apiResponse.totalItems
      } catch (error) {
        if (!error.code || error.code !== 1) {
          this.addAlert({texto: error.message, color: 'error'})
        }
      }
      this.inLoading = false
    },
    async eliminarReserva (eliminar) {
      if (!eliminar) {
        this.mostrarPopUpEliminar = false
        return
      }
      try {
        this.eliminandoReserva = true
        await this.eliminar(this.reservaSeleccionada.id)
        this.loadItems()
        this.mostrarPopUpEliminar = false
        this.eliminandoReserva = false
        this.addAlert({texto: this.$t('reservas.listas.reservaCanceladoExito'), color: 'success'})
      } catch (error) {
        if (!error.code || error.code !== 1) {
          this.addAlert({texto: error.message, color: 'error'})
        }
        this.mostrarPopUpEliminar = false
        this.eliminandoReserva = false
      }
    },
    async eliminadaBO (reserva) {
      try {
        this.eliminandoReserva = true
        await this.loadItems()
        this.mostrarPopUpEliminar = false
        this.eliminandoReserva = false
        if (reserva.actor) {
          this.addAlert({texto: this.$t('reservas.listas.emailEnviado', {email: reserva.actor.email}), color: 'success'})
        } else {
          this.addAlert({texto: this.$t('reservas.listas.emailNoEnviadoSimp'), color: 'success'})
        }
      } catch (error) {
        if (!error.code || error.code !== 1) {
          this.addAlert({texto: error.message, color: 'error'})
        }
        this.mostrarPopUpEliminar = false
        this.eliminandoReserva = false
      }
    },
    getNombreCliente (reserva) {
      // CONCAT(apellidos,", ", nombre, " (", email, ")")
      return (reserva != null && reserva != null) ? (reserva.actor.apellidos != null ? (reserva.actor.apellidos + ', ') : '') + (reserva.actor.nombre != null ? (reserva.actor.nombre + ' ') : '') + (reserva.actor.email != null ? ('(' + reserva.actor.email + ')') : '') : ''
    },
    nombreActor () {
      return (this.reservaSeleccionada != null && this.reservaSeleccionada.actor != null) ? this.reservaSeleccionada.actor.nombre + ' ' + this.reservaSeleccionada.actor.apellidos : ''
    },
    situacionReserva (reserva) {
      if (!this.eliminadaOAnulada(reserva) && !reserva.sincronizada) {
        return this.$t('reservas.listas.sinSincronizar')
      }
      switch (reserva.estado) {
        case 1:
          return this.reservaEnRevision(reserva) ? this.$t('reservas.listas.pendienteReserva') : this.$t('reservas.listas.enProcesoPreReserva')
        case 10:
          return this.estaCaducada(reserva) ? this.$t('reservas.listas.caducada') : (this.reservaEnRevision(reserva) ? this.$t('reservas.listas.pendienteRevisionActiva') : this.$t('reservas.listas.enProcesoActiva'))
        case 20:
          return this.$t('reservas.listas.terminada')
        case 90:
        case 93:
          return this.$t('reservas.listas.eliminada')
        case 91:
          return this.$t('reservas.listas.anulada')
        default:
          return this.$t('reservas.listas.estadoNoDefinido')
      }
    },
    reservaEnRevision (reserva) {
      let indiceActual = this.getModuloActual(reserva)
      if (reserva.modulosOrden.modulos.length <= indiceActual || indiceActual < 0) {
        return false
      }
      const tipo = reserva.modulosOrden.modulos[indiceActual].tipo
      const codigoEstado = this.getModuloCodigo(tipo, reserva)
      return codigoEstado === 5 || (tipo === 'pbc' && [6, 91, 92].includes(codigoEstado))
    },
    reservaSincronizada (reserva) {
      return this.estadoSincronizado(reserva.estadoSincronizacion) &&
      this.estadoSincronizado(reserva.estadoSincronizacionPago) &&
      this.estadoSincronizado(reserva.estadoSincronizacionContrato) &&
      this.estadoSincronizado(reserva.estadoSincronizacionKyc) &&
      this.estadoSincronizado(reserva.estadoSincronizacionDocumentacion) &&
      this.estadoSincronizado(reserva.estadoSincronizacionPBC) &&
      this.estadoSincronizado(reserva.estadoSincronizacionCancelacion)
    },
    estadoSincronizado (estado) {
      return ![10, 80].includes(estado)
    },
    mostrarVistaPrevia (obj) {
      if (obj.modulosOrden.simplificada == 1) {
        this.$router.push({name: 'reservas.id.simplificada', params: {id: obj.id}})
      } else {
        this.$router.push({name: 'reservas.id', params: {id: obj.id, skip: true}})
      }      
    },
    mostrarCambiarEstado (obj) {
      this.cambiado = false
      this.reservaSeleccionada = obj
      this.mostrarPopUpCambiarEstado = true
    },
    mostrarEnviarRecordatorio (obj) {
      this.reservaSeleccionada = obj
      this.mostrarPopUpEnviarRecordatorio = true
    },
    mostrarSincronizar (obj) {
      this.reservaSeleccionada = obj
      this.mostrarPopUpSincronizar = true
    },
    mostrarEliminar (obj) {
      this.reservaSeleccionada = obj
      this.mostrarPopUpEliminar = true
    },
    estaCaducada (reserva) {
      return moment().isAfter(reserva.fechaLimite)
    },
    eliminadaOAnulada (reserva) {
      return reserva.estado === 91 || reserva.estado === 90 || reserva.estado === 93
    },
    eliminada (reserva) {
      return reserva.estado === 90 || reserva.estado === 93
    },
    terminada (reserva) {
      return reserva.estado === 20
    }
  },
  watch: {
    pagination: {
      deep: true,
      handler () {
        this.loadItems()
      }
    },
    tipoReserva: {
      deep: true,
      handler () {
        this.loadItems()
      }
    },
    promocionesSelect: {
      deep: true,
      handler () {
        this.loadItems()
      }
    },
    checkSelect: {
      deep: true,
      handler () {
        this.loadItems()
      }
    },
    search (newVal, oldVal) {
      if (
        newVal !== oldVal &&
        ((newVal != null && newVal.length >= 3) || (oldVal != null && oldVal.length >= 3))
      ) {
        this.loadItems()
      }
    },
    cambiado () {
      this.$emit('cambiado', this.cambiado)
    }
  }
}
</script>

<style lang="stylus">
@require '~vuetify/src/stylus/settings/_colors'

.modulosStyle
  width: 10px
  height: 20px
  margin: 2px
  border: 1.6px solid

.pendiente
  border-color: grey
  background-color: $grey["lighten-2"]

.aceptada
  border-color: green
  background-color: $green["lighten-3"]

.revision
  border-color: $yellow["darken-1"]
  background-color: $yellow["lighten-3"]

.rechazada
  border-color: red
  background-color: $red["lighten-3"]

</style>



// WEBPACK FOOTER //
// src/components/reservas/listas/TableReservaListaCliente.vue